import React from 'react';
import {connect} from 'react-redux';
import * as ResourceApi from "../../../api/resources";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {
    cancelSelectedDeleteAction,
    deleteSelectedTagAction,
    endDeleteBreakTagAction,
    selectTagForDeletion
} from "./actions";
import BasicModal from "../../../components/common/BasicModal";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {isNoU} from "../../../utils/DBUtils";
import {List} from "semantic-ui-react";

const DeleteBreakTagView = (props) => {
    let confirmingDelete = !isNoU(props.confirmation);
    let selectedTag = props.loadedTags.find((tag) => tag.id === props.selectedTagId);
    return (
        <BasicModal header={"Delete Tags"}
                    open={props.open}
                    onClose={props.close}
                    specialType="primary-modal delete-break-tags-modal"
                    actions={[
                        {
                            label: confirmingDelete ? "Cancel" : "Done",
                            displayType: "button",
                            action: confirmingDelete ? props.cancelSelectedDelete : props.close,
                            loading: props.deletionInProgress
                        },
                    ]}>
            <Button className="delete-button"
                    fluid
                    negative
                    disabled={!props.canDelete}
                    loading={props.deletionInProgress}
                    onClick={props.deleteTag}>
                {confirmingDelete ? "Confirm Delete" : "Delete"}
            </Button>
            {confirmingDelete ? (
                <div>
                    <h3>The following breaks will have the '{selectedTag.label}' tag removed. If they have published versions, those will be republished.</h3>
                    <List items={props.confirmationInfo}/>
                </div>
            ) : (
                <Dropdown placeholder='Search Tags'
                          fluid
                          search
                          selection
                          value={props.selectedTagId}
                          onChange={(e, data) => props.selectTag(data.value)}
                          options={props.loadedTags.map((tag) => {
                              let translations = tag.translations || {};
                              // get first translation
                              let translation = "";
                              for (let key of Object.keys(translations)) {
                                  if (!isNoU(translations[key])) {
                                      translation = translations[key];
                                      break;
                                  }
                              }
                              return {
                                  value: tag.id,
                                  text: translation,
                                  key: tag.id
                              };
                          })}/>
            )}
        </BasicModal>
    )
};

const mapState = ({resources, deleteBreakTagModal}) => {
    let loadedTags = Object.keys(resources.resources)
    // get only BreakTag resources
        .filter((key) => {
            const resource = resources.resources[key];
            const resourceId = resource.resourceId;
            return resource && resourceId && resourceId.type === ResourceApi.Types.BreakTag
        })
        // map to value
        .map((key) => resources.resources[key]);

    let open = deleteBreakTagModal.deletingBreakTags;
    let canDelete = !isNoU(deleteBreakTagModal.toDelete);
    let deletionInProgress = deleteBreakTagModal.deletionInProgress;
    let selectedTagId = deleteBreakTagModal.toDelete;
    let confirmation = deleteBreakTagModal.deleteConfirmation;
    let confirmationInfo = deleteBreakTagModal.deleteConfirmationInfo;

    return {
        loadedTags,
        open,
        canDelete,
        deletionInProgress,
        selectedTagId,
        confirmation,
        confirmationInfo
    };
};

const mapDispatch = (dispatch) => {
    return {
        selectTag: (tagLabel) => dispatch(selectTagForDeletion(tagLabel)),
        close: () => dispatch(endDeleteBreakTagAction()),
        deleteTag: () => dispatch(deleteSelectedTagAction()),
        cancelSelectedDelete: () => dispatch(cancelSelectedDeleteAction())
    }
};

const DeleteBreakTagModal = connect(mapState, mapDispatch)(DeleteBreakTagView);

export default DeleteBreakTagModal;



// WEBPACK FOOTER //
// ./public/pages/EditBreak/DeleteBreakTagModal/DeleteBreakTagModal.jsx